import React from 'react';

const Intro = () =>
    <section id="intro" className="clearfix main">
        <div className="container-fluid">
            <div className="row">
                <div className="col-xs-12 col-sm-offset-1 col-sm-8 col-md-offset-3 col-md-6 col-lg-5">
                    <p>Hi, I'm a data visualization designer and developer. I enjoy solving data viz puzzles with code and making data explorable through interactivity on the web.</p>
                </div>
            </div>
        </div>
    </section>

export default Intro;
